import { ObjectMapper } from 'json-object-mapper';
import { EmployeeType } from 'services/enums/EmployeeType.enum';
import { WorkRegimeType } from 'services/enums/WorkRegimeType.enum';
import { CompanyModel } from './company.model';
import { IModel } from './IModel';
import { Model, OptionModel } from './model';

export class EmployeeModel extends Model implements IModel<EmployeeModel> {
  name: string = '';
  displayName: string = '';
  socialName: string = '';
  cpf: string = '';
  cnpj: string = '';
  registration: string = '';
  pis: string = '';
  rg: string = '';
  password: string = '';
  admissionDate: string = '';
  birthday: string = '';
  timeAtCompany: string = '';
  age: number = 0;
  email: string = '';
  fathersName: string = '';
  mothersName: string = '';
  birthCity: string = '';
  costCenterId: string | undefined = undefined;
  costCenterCode: string = '';
  costCenterName: string = '';
  timeShiftId: string | undefined = undefined;
  timeShiftCode: string = '';
  timeShiftTitle: string = '';
  jobTitleId: string | undefined = undefined;
  jobTitleCode: string = '';
  jobTitleName: string = '';
  companyCNPJ: string = '';
  companyName: string = '';
  companyId: string | undefined = undefined;
  workRegime: number = WorkRegimeType.CLT.id;
  type: any = EmployeeType.NORMAL.id;
  salary: number = 0;
  foreignId: string | undefined = undefined;
  companyGroupId: string | undefined = undefined;
  cellPhoneNumber: string = '';
  profileImagePath: string = '';
  shortProfileImagePath: string = '';
  accessProfileId: string | undefined = undefined;
  tradeUnionId: string | undefined = undefined;
  company: CompanyModel = new CompanyModel();
  hasIntegration: boolean = true;
  isAway: boolean = false;

  street: string = "";
  neighborhood: string = "";
  city: string = "";
  state: string = "";
  emergencyName: string = "";
  emergencyKinship: string = "";
  emergencyEmail: string = "";
  emergencyContact: string = "";

  shoeSize: number = 0;
  shirtSize: string = "";
  pantsSize: number = 0;

  static create(input: any): EmployeeModel {
    return ObjectMapper.deserialize<EmployeeModel>(EmployeeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  public toOption(): OptionModel {
    return {
      label: `${this.name} - ${this.registration} `,
      value: this.id,
    } as OptionModel;
  }
}
